import React, { } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, Field, Model, ModelMobile, POST, errorCatch, updateInArray, useAuth } from 'fennec-ui';
import { useBreadcrumbs, useTeacherContext, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext } from '../../../../../common/Context';
import CapsuleMenu from '../../../../components/CapsuleMenu';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Settings(props) {
    let { id } = useParams();
    const auth = useAuth();

    // const sourceKey = "promouter";
    // const [event, setEvent] = useState(undefined);
    // useEffect(() => {
    //     GET(auth, `/api/meropriyatiya/list/${sourceKey}?detail=model&w-id=${id}`,
    //         ({ data }) => {
    //             if (data && data.length) {
    //                 setEvent(data[0]);
    //             }
    //         }, errorCatch);
    // }, [])

    const [teacher, setTeacher] = useTeacherContext()
    const osnovi = _.get(teacher, "osnoviPromokodovPrepodavatelFederatsii[0]")

    // ----------------------------------------
    const breadcrumbs = useBreadcrumbs()
    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if (count >= i) return p;
            if (!arr[idx]?.context) {
                count++
            }
            p += `/${arr[idx]?.uuid}`
        }
        return p
    }
    // ----------------------------------------

    return (
        <div className="subcontent">
            <div className={"content"}>
                <PageLayout hideSider={true}>
                    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "white", padding: "4px 10px", borderRadius: "4px" }}>
                        <div>
                            <div>
                                <div style={{ fontSize: "16px" }}>Параметры промокодов</div>
                                {/* <div style={{ color: "rgb(140, 152, 164)", fontSize: "12px" }}>
                            Параметры промокодов
                        </div> */}
                            </div>
                            <div className='action-inline'>
                                <Action
                                    auth={auth}
                                    okText="Сохранить"
                                    action={(values, unlock, close) => {
                                        // "/api/osnovipromokodov/new"
                                        // "/api/osnovipromokodov/update"
                                        // "/api/osnovipromokodov/delete"

                                        if (values?.osnovaPromokoda && values?.osnovaPromokoda !== "") {
                                            POST(auth, (!osnovi) ? `/api/osnovipromokodov/new` : `/api/osnovipromokodov/update`, {
                                                ID: (osnovi) ? osnovi.ID : undefined,
                                                prepodavatelShkoliID: undefined,
                                                shkolaFederatsiiID: undefined,
                                                prepodavatelFederatsiiID: teacher?.ID,
                                                organizatorFederatsiiID: undefined,
                                                osnovaPromokoda: values?.osnovaPromokoda,
                                            }, ({ data }) => {
                                                setTeacher({ ...teacher, osnoviPromokodovPrepodavatelFederatsii: updateInArray(teacher?.osnoviPromokodovPrepodavatelFederatsii, data) })
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else if (osnovi) {
                                            POST(auth, `/api/osnovipromokodov/delete`, {
                                                ID: (osnovi) ? osnovi.ID : undefined,
                                                prepodavatelShkoliID: undefined,
                                                shkolaFederatsiiID: undefined,
                                                prepodavatelFederatsiiID: teacher?.ID,
                                                organizatorFederatsiiID: undefined,
                                                osnovaPromokoda: values?.osnovaPromokoda,
                                            }, ({ data }) => {
                                                setTeacher({ ...teacher, osnoviPromokodovPrepodavatelFederatsii: [] })
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        }

                                    }}

                                    object={osnovi}
                                    // disabledOkOnUncahngedForm={true}

                                    form={ModelMobile}
                                    meta={[
                                        {
                                            label: "Основа промокода",
                                            description: (<span><i className="fa fa-question-circle"></i> Применяется в качестве префикса при выдаче промокода организатором мероприятия</span>),
                                            name: "osnovaPromokoda",
                                            type: "string",
                                            size: "small"
                                        }
                                    ]}
                                    mode={"inline"}
                                />
                            </div>
                        </div>
                    </div>
                </PageLayout>
            </div>
            <div className={"footer"}>
                <CapsuleMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} />

                {/* <TabsMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} /> */}
                {/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}

            </div>
        </div>
    );
}
